<template>
  <div class="view user-view">
    <div class="content">
      <div class="jll-logo"></div>
      <LanguageSelector :main="false" />
      <div class="commuter-logo"></div>
      <RouterView class="component-content"></RouterView>
    </div>
    <div class="illustration"></div>
  </div>
</template>

<script>
import LanguageSelector from '@/components/Topbar/LanguageSelector';

export default {
  components: {
    LanguageSelector,
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/animations.scss';

.user-view {
  width: 100%;
  height: 100vh;
  display: flex;
  background: colors.$dark-color;
  color: colors.$white-color;

  .content {
    display: flex;
    flex-direction: column;
    min-width: 512px;
    width: 30%;
    padding: 24px;
    flex-shrink: 0;
    box-sizing: border-box;
    overflow-y: auto;

    .jll-logo {
      width: 64px;
      height: 32px;
      flex-shrink: 0;
      background-image: url('./../../assets/JLLLogo-White.png');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    }

    .commuter-logo {
      margin: 32px auto 48px;
      width: 192px;
      height: 96px;
      flex-shrink: 0;
      background-image: url('./../../assets/CommuterLogo-White.svg');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    }

    .component-content {
      flex-grow: 1;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media (min-height: 880px) {
        padding: 0 0 128px 0;
      }
    }

    .responsive-message {
      display: none;
    }
  }

  .illustration {
    flex-grow: 1;
    height: 100%;
    background-image: url('./../../assets/LoginIllustration.png');
    background-repeat: no-repeat;
    background-position: center left;
    background-size: cover;
  }
}
</style>
